<template>
  <x-page title="申请售后" :loading="loading">
    <template v-if="!loading">
      <x-card title="售后商品" class="goods">
        <div class="hd">
          <van-image :src="$state.goodsData.pic" class="cover" fit="cover" />
          <div class="content">
            <div :class="['name', _._ellipsis2]">
              {{ $state.goodsData.name }}
            </div>
            <div class="desc">{{ $state.goodsData.skuSpecs }}</div>
            <div class="extra">
              <div class="price">￥{{ $state.goodsData.unitPrice }}</div>
              <div v-if="$state.fromInstantDelivery" class="amount">
                共{{ $state.orderData.commodities.length }}件商品
              </div>
              <div v-else class="amount">x{{ $state.goodsData.quantity }}</div>
            </div>
          </div>
        </div>
        <div
          v-if="$state.delivered && !$state.fromInstantDelivery"
          :class="['bd', _._hairlineTop]"
        >
          <div class="label">申请数量</div>
          <x-stepper
            v-model="$state.requestAmount"
            class="value"
            disable-input
            :min="1"
            :max="$state.goodsData.quantity"
          />
        </div>
      </x-card>
      <router-view />
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { afterSalesModel } from './_model'
  import { AfterSalesType } from '../_model'
  import {
    apiOrderOrderDetail,
    apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterType,
  } from '@/api'
  import { mapQuery, prepareData } from '@/utils'

  export default Vue.extend({
    noKeepalive: true,

    mixins: [
      afterSalesModel.mixin,
      mapQuery({
        commodityId: {
          key: ['commodityId', 'goodsId'],
        },
        skuId: 'skuId',
        orderNo: 'orderNo',
        fromInstantDelivery: 'fromInstantDelivery',
      }),
    ],

    data: () => ({
      // 页面级加载状态
      loading: true,
    }),

    created() {
      afterSalesModel.update({
        goodsId: this.commodityId,
        skuId: this.skuId,
        orderNo: this.orderNo,
        fromInstantDelivery: !!this.fromInstantDelivery,
      })
    },

    async mounted() {
      const { orderData } = await prepareData({
        orderData: apiOrderOrderDetail({
          orderNo: afterSalesModel.state.orderNo,
        }),
      })
      const goodsData = afterSalesModel.state.fromInstantDelivery
        ? orderData.commodities[0]
        : orderData.commodities.find(
            item =>
              item.commodityId === afterSalesModel.state.goodsId &&
              item.skuId === afterSalesModel.state.skuId,
          )
      afterSalesModel.update({
        skuId: goodsData.skuId,
        orderData: orderData,
        goodsData: goodsData,
        delivered: goodsData.shipStatus === 1,
        requestAmount: goodsData.quantity,
      })
      if (afterSalesModel.state.fromInstantDelivery) {
        afterSalesModel.update({
          supportAfterSalesTypes: [AfterSalesType.退款],
        })
      } else {
        const { supportData } = await prepareData({
          supportData:
            apiSaleAfterStandardEcommerceSaleAfterGetAvailableSaleAfterType({
              refOrderNo: afterSalesModel.state.orderNo,
              skuId: afterSalesModel.state.skuId,
            }),
        })
        afterSalesModel.update({
          supportAfterSalesTypes: [
            !supportData.refundOnlyCloseFlag && AfterSalesType.退款,
            !supportData.refundAndReturnCloseFlag && AfterSalesType.退货退款,
            !supportData.exchangeCloseFlag && AfterSalesType.换货,
          ].filter(Boolean),
          canSelfDelivery: !!supportData.selfDeliver,
          canPickup: !!supportData.pickup,
        })
      }
      this.loading = false
    },
  })
</script>

<style lang="scss" scoped>
  .goods {
    .hd {
      display: flex;
      align-items: stretch;

      .cover {
        flex-shrink: 0;
        width: 85px;
        height: 85px;
        border-radius: 8px;
        overflow: hidden;
      }

      .content {
        flex-grow: 1;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .name {
          font-size: 14px;
          color: #222222;
          line-height: 20px;
          word-break: break-all;
        }

        .desc {
          font-size: 12px;
          color: #888888;
        }

        .extra {
          display: flex;
          align-items: center;

          .price {
            font-size: 14px;
            font-weight: bold;
            color: #222222;
          }

          .amount {
            margin-left: 8px;
            font-size: 12px;
            color: #bebebe;
          }
        }
      }
    }

    .bd {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 8px;

      .label {
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
    }
  }
</style>
